// ** MUI Imports
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
} from "@mui/material";

// ** Custom Component Imports
import CustomTextField from "components/mui/text-field";

const AddIndustry = ({ open, handleClose, IndustryProps }) => {
  const {
    industryContent,
    industry,
    handleChange,
    errors,
    handleSave,
    btnDisabled
  } = IndustryProps;

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth="xs"
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #D9D9D9",
            paddingBottom: "20px !important",
          }}
        >
          <Box>
            <Typography variant="h4" fontWeight="bold">
              {industryContent.title}
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={5}>
            <Grid item xs={12} md={10}>
              <CustomTextField
                fullWidth
                required
                label="Industry Name"
                name='industryName'
                value={industry.industryName}
                placeholder="Enter your desired industry name"
                onChange={handleChange}
                error={errors.industryName}
                helperText={errors.industryName ? 'This field is required' : ''}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            padding: "20px 24px !important",
            boxShadow: `0px -4px 8px rgb(0, 0, 0, 0.1)`,
            zIndex: 1,
          }}
          className="dialog-actions-dense"
        >
          <Box>
            <Button variant="contained" color="info" onClick={handleClose}>
              Cancel
            </Button>
          </Box>
          <Box>
            <Button variant="contained" color="main" onClick={handleSave} disabled={btnDisabled}>
              {industryContent.btnText}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddIndustry;
